export const MISSING_SUBSCRIPTION = 'MISSING_SUBSCRIPTION';
export const NOT_AUTHENTICATED = 'NOT_AUTHENTICATED';

export default {
  MISSING_SUBSCRIPTION,
  NOT_AUTHENTICATED,
};
